import React from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
	return (
		<nav className="navbar navbar-expand-lg fixed-top navbar-dark ">
			<div
				className="collapse navbar-collapse"
				id="navbarNav"
			>
				<ul className="navbar-nav mx-auto">
					<li className="nav-item">
						<NavLink
							exact="true"
							className="nav-link"
							activeclassname="active"
							to="/"
						>
							Home
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink
							exact="true"
							className="nav-link"
							activeclassname="active"
							to="/About"
						>
							About
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink
							exact="true"
							className="nav-link"
							activeclassname="active"
							to="/things-to-do"
						>
							Things to do
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink
							exact="true"
							className="nav-link"
							activeclassname="active"
							to="/what-to-eat"
						>
							What to eat
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink
							exact="true"
							className="nav-link"
							activeclassname="active"
							to="/gallery"
						>
							Gallery
						</NavLink>
					</li>
				</ul>
			</div>
		</nav>
	);
}

export default Navbar;
